<template>
    <Address slot="content"/>
</template>

<script>
import Address from '@/components/custom/admin/forms/add-address/Address'

export default {
    name: 'SingleAddressEdit',

    components: {
        Address
    }
}
</script>